import React, { Component } from 'react';
import preview1 from './Drift-preview.jpg';
import preview2 from './Classic-preview.jpg';
import preview3 from './Damian-preview.jpg';
import { Parallax, Background } from 'react-parallax';

class Homepage extends Component {
  render() {
    return (
      <div className="container-fluid">

        <h1>
          Panku Media
        </h1>

        <p>
        Welcome to the all new Panku Media website! My name is Travis Slocum, and I have a passion for automotive photography and videography as well as anything cars! Take a look around, on the gallery page you'll see pictures from some of my recent photoshoots. If you'd like to inquire about anything, info on how to do so is on the contact page, where you'll also find links to all my social media!
        </p>

        <p>
        My goal is to make people smile. Nothing makes me happier than to show someone a rad shot or a sweet video of their car, and see the joy take over their face. I'll photograph anything, and everything!
        </p>
        <h9>
         <Parallax
          blur={0}
          bgImage={require('./Drift-preview.jpg')}
          bgImageAlt="Drift"
          strength={200}
          >
           <h21>
            Whether it's a beat up drift car with no bumpers,
           </h21>
           <div style={{ height: '600px' }} />
         </Parallax>
         <Parallax
          blur={0}
          bgImage={require('./Classic-preview.jpg')}
          bgImageAlt="Classic"
          strength={200}
          >
          <h21>
            A restored classic
          </h21>
          <div style={{ height: '600px' }} />
        </Parallax>
        <h20>
          <Parallax
            blur={0}
            bgImage={require('./Damian-preview.jpg')}
            bgImageAlt="Damian"
            strength={200}
            >
            <h21>
              Or a fancy car that only gets driven on nice weekends.
            </h21>
          <div style={{ height: '600px' }} />
         </Parallax>
        </h20>
      </h9>
      <h12>
         They're all works of art to me!
      </h12>
     </div>
    );
  }
}


export default Homepage;
